/* Character deep link for the shop page.

   A link like /pages/shop?char=fancy opens the shop with that character
   already selected; adding &type=shirt narrows it to a product type as well.
   It works by clicking the rail button a shopper would have clicked
   themselves, so the colour theming, story panel, pill counts and
   collection-driven ordering all follow exactly as on a real click.

   Arriving from a link (a fresh navigation), the page jumps straight down to
   the shop so the filtered products are what the shopper sees first, rather
   than the banner above it.

   The address bar is kept in step with whatever the shopper picks, so the
   back button returns them to the character and filter they last had, and
   the browser restores their scroll position. On back/forward and reload the
   page is never jumped, so their place is not lost.

   An unknown, empty or misspelled value is ignored and the page opens on
   Shop All, so an old link is never a dead end.

   Timing: the section registers its own DOMContentLoaded handler while the
   page is still parsing, and this file is deferred, so its handler always
   runs second, after the rail has been wired up. */
(function () {
  function esc(v) {
    return v.replace(/["\\]/g, '\\$&');
  }

  function navType() {
    try {
      var e = performance.getEntriesByType('navigation')[0];
      if (e && e.type) return e.type;
    } catch (err) {}
    return 'navigate';
  }

  function headerBottom() {
    var hg = document.getElementById('header-group');
    if (!hg) return 0;
    var r = hg.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }

  function syncUrl(charKey, typeKey) {
    try {
      var u = new URL(window.location.href);
      if (charKey && charKey !== 'all') u.searchParams.set('char', charKey);
      else u.searchParams.delete('char');
      if (typeKey && typeKey !== 'all') u.searchParams.set('type', typeKey);
      else u.searchParams.delete('type');
      var next = u.pathname + u.search + u.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        history.replaceState(history.state, '', next);
      }
    } catch (e) {}
  }

  function run() {
    var rail = document.querySelector('.ffcs-rail');
    if (!rail) return;
    var root = rail.closest('.shopify-section') || document.body;

    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) {}
    var wantChar = params ? (params.get('char') || '').trim().toLowerCase() : '';
    var wantType = params ? (params.get('type') || '').trim().toLowerCase() : '';

    var curChar = 'all';
    var curType = 'all';
    var applied = false;

    if (wantChar && wantChar !== 'all') {
      var btn = rail.querySelector('.ffcs-btn[data-char="' + esc(wantChar) + '"]');
      if (btn) {
        btn.click();
        curChar = wantChar;
        applied = true;
      }
    }

    /* A character click resets the pills, so the type is applied second. A
       pill that has nothing for this character is hidden, so it is skipped
       rather than opening onto an empty grid. */
    if (wantType && wantType !== 'all') {
      var pill = root.querySelector('.ffcs-pill[data-type="' + esc(wantType) + '"]');
      if (pill && !pill.classList.contains('is-empty')) {
        pill.click();
        curType = wantType;
        applied = true;
      }
    }

    /* Drop anything in the link that did not match, so the address bar only
       ever shows what is actually on screen. */
    if (wantChar || wantType) syncUrl(curChar, curType);

    /* From here on, follow the shopper's own picks. Registered after the
       clicks above so those are not counted twice. */
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('.ffcs-btn');
      if (!b) return;
      curChar = b.getAttribute('data-char') || 'all';
      curType = 'all';
      syncUrl(curChar, curType);
    });
    root.addEventListener('click', function (e) {
      var p = e.target.closest('.ffcs-pill');
      if (!p) return;
      curType = p.getAttribute('data-type') || 'all';
      syncUrl(curChar, curType);
    });

    if (!applied || navType() !== 'navigate') return;

    /* Jump to the shop. Photos and video above it can still be loading and
       push it down, so it is re-aimed once the page finishes loading, unless
       the shopper has already started scrolling themselves. */
    var userMoved = false;
    function mark() { userMoved = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, mark, { passive: true, once: true });
    });
    function jump() {
      if (userMoved) return;
      var y = root.getBoundingClientRect().top + window.pageYOffset - headerBottom();
      window.scrollTo(0, Math.max(0, Math.round(y)));
    }
    jump();
    if (document.readyState === 'complete') {
      requestAnimationFrame(jump);
    } else {
      window.addEventListener('load', function () { requestAnimationFrame(jump); }, { once: true });
    }
  }

  document.addEventListener('DOMContentLoaded', run);
})();
